import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

const items = [
  { id: 1, title: "Etailers", image: "/Etailers.png" },
  { id: 2, title: "System Integrators", image: "/System_integrators.png" },
  { id: 3, title: "Gamers", image: "/Gamers.png" },
  { id: 4, title: "Bidders", image: "/Bidders.png" },
  { id: 5, title: "Amazon Marketplace", image: "/Amazon.png" },
  { id: 6, title: "Retailers", image: "/Retailers.png" },
  { id: 7, title: "Distributors", image: "/Distributors.png" },
];

const approachItems = [
  { id: 1, text: "Identifying key resellers.", image: "/resellers.png" },
  { id: 2, text: "Organizing the distribution network to ensure efficiency and coverage", image: "/optimizacion.png" },
  { id: 3, text: "Coordinating both channel-specific and generalist promotional and marketing campaigns", image: "/precios.png" },
  { id: 4, text: "Organizing the channel and control pricing in the market. Management of sellout rebate programs. MDF programs.", image: "/mkt.png" },
];

const HowWeWork = () => {
  return (
    <Box
      sx={{ 
        p: { xs: 2, md: 4 }, 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems:'center', 
        justifyContent:'space-evenly'
      }}
    >
      {/* Título */}
      <Typography 
        variant="h3" 
        align="center" 
        gutterBottom 
        sx={{
          color: 'rgb(3,116,206)', 
          fontWeight: 'bold',
          fontSize: { xs: '2rem', md: '3rem' }
        }}
      >
        How We Work
      </Typography>

      {/* Texto descriptivo */}
      <Typography 
        variant="h6" 
        align="center" 
        mb={4} 
        sx={{
          width: { xs: '90%', md: '70%' },
          fontSize: { xs: '1rem', md: '1.25rem' }
        }}
      >
        We design tailored strategies for each brand, selecting the most suitable channels and adapting to each country and market context. We coordinate actions among the key industry players:
      </Typography>

      {/* Listado de 7 ítems en dos columnas */}
      <Grid container spacing={3}>
        {items.map((item) => {
          const isOdd = item.id % 2 !== 0;
          return (
            <Grid 
              key={item.id} 
              item 
              xs={12} 
              sm={6} 
              sx={{ display: 'flex', justifyContent: 'center' }}
            >
              <Box 
                sx={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  justifyContent: { xs: 'center', md: 'flex-start' },
                  height: '5rem',
                  width: { xs: '100%', sm: '20rem' },
                  // Solo en pantallas md o mayores se aplica el offset alternado
                  ml: { xs: 0, lg: isOdd ? '20rem' : '-20rem' },
                  transition: 'margin 0.3s'
                }}
              >
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}${item.image}`}
                  alt={item.title}
                  sx={{
                    width: 70,
                    height: 70,
                    objectFit: 'contain',
                    mr: 2,
                  }}
                />
                <Typography variant="h6">
                  {item.title}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      {/* Sección "Our approach includes:" */}
      <Box 
        sx={{ 
          width: '100%',
          minHeight: { xs: 'auto', md: '55vh' },
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          backgroundColor: 'rgb(139,206,252, 0.45)',
          mt: 3,
          boxShadow: '0px -2px 8px rgba(3,115,206,0.59), 0px 2px 8px rgba(3,115,206,0.59)',
          p: { xs: 2, md: 4 }
        }}
      >
        <Typography 
          variant="h4" 
          align="center" 
          gutterBottom 
          sx={{ mt: { xs: 2, md: 6 }, fontWeight:'bold' }}
        >
          Our approach includes:
        </Typography>
        <Grid 
          container 
          spacing={3} 
          sx={{ width: { xs: '100%', md: '65rem' } }}
        >
          {approachItems.map((item) => (
            <Grid key={item.id} item xs={12} sm={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                <Box
                  component="img"
                  src={`${process.env.PUBLIC_URL}${item.image}`}
                  alt={item.text}
                  sx={{
                    width: 80,
                    height: 80,
                    objectFit: 'cover',
                    mr: 2,
                  }}
                />
                <Typography variant="h6">
                  {item.text}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default HowWeWork;
